export default "__VITE_ASSET__ZR1BceHO__"